export enum IncidentStatus {
    Unknown = 0,
    Open = 1,
    Closed = 2
}